<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <el-form :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="套餐搜索：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请搜索套餐名称搜索"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-button @click="editBannerBtn('')" size="small" type="primary" class="bg-theme">添加套餐</el-button>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="setMealName"
            label="套餐名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="setMealPrice"
            label="套餐价格">
          </el-table-column>
          <el-table-column
            align="center"
            prop="sort"
            label="排序">
          </el-table-column>
          <el-table-column
            align="center"
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 1" class="mt-green">开启</span>
              <span v-else class="mt-red">禁用</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="updateTime"
            label="更新时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="editBannerBtn(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="delBannerBtn(scope.row.id)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryGoodsSetMealComboPageList, removeGoodsSetMealComboById } from '@/api/setMenu'
export default {
  name: 'Banner',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      queryGoodsSetMealComboPageList({ setMealName: searchName,pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          data.forEach(function(item) {
            if(item.type === 0){
              item.wjcontent = '--';
            }else if(item.type === 1){
              item.wjcontent = item.url;
            }else if(item.type === 2){
              item.wjcontent = item.url;
            }else{
              item.wjcontent = 'APPID:'+item.minAppId;
            }
          });
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    /* 轮播图-编辑 */
    editBannerBtn (infoId) {
      this.$router.push({path: '/set_menu_add', query: {dataId: infoId}})
    },
    /* 轮播图-删除 */
    delBannerBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeGoodsSetMealComboById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/setMenu/SetMenu.vue